
// Replaces liquid based routing with JS based routing due to added page route outside of liquid templating
window.activeAccountBannerItem = function activeAccountBannerItem(pageUrl) {
  let activeSelector = null;

  if (pageUrl === "/account") {
    activeSelector = ".account-orders__trigger";
  } else if (pageUrl === "/account/addresses") {
    activeSelector = ".account-address__trigger";
  } else if (pageUrl === "/account/?page=account-details") {
    activeSelector = ".account-details__trigger";
    document.querySelector(".account-orders__container").classList.add("hidden");
  }

  // Remove aria-current from all elements that might have it
  document.querySelectorAll("[aria-current='page']").forEach((item) => {
    item.removeAttribute("aria-current");
  });

  if (activeSelector) {
    const activeElement = document.querySelector(activeSelector);
    if (activeElement) {
      activeElement.setAttribute("aria-current", "page");
    }
  }
}

window.getGraphQLVariables = function getGraphQLVariables(formData, customerAccessToken) {
  return {
    customer: {
      firstName: formData?.firstName,
      lastName: formData?.lastName,
      acceptsMarketing: formData?.emailSubscription
    },
    customerAccessToken
  };
};

window.handleGraphQLResponse = function handleGraphQLResponse(result, formData) {
  const errors = result.data.customerUpdate.customerUserErrors;
  if (errors.length > 0) {
    displayMessage(errors[0].message);
  } else {
    updateKlaviyoData(formData);
    document.querySelector(".customer-welcome__heading").innerHTML = `Welcome, ${formData?.firstName}`;
    displayMessage("Customer details updated successfully!");
  }
};

function updateKlaviyoData(formData) {
  if (!formData.firstName || !formData.lastName || !formData.email || !formData.emailSubscription) return;
  const groups = (window.OnetrustActiveGroups || '').split(',');
  if (groups.indexOf('C0004') === -1) return;
  if (typeof klaviyo === 'undefined' || !klaviyo.push) return;
  klaviyo.push([
    'identify',
    {
      '$first_name': formData?.firstName,
      '$last_name': formData?.lastName,
      '$email': formData?.email,
      '$consent': formData?.emailSubscription ? ['email'] : []
    }
  ]);
}

window.displayMessage = function displayMessage(message) {
  document.getElementById('response-message').innerText = message;
};

window.changePassword = async function changePassword(email) {
  if (!email.length) return false;

  try {
    const responseData = await sendGraphQLRequest(changePasswordQuery, { email });

    const { data, errors } = responseData;
    if (errors || data?.customerRecover?.customerUserErrors?.length) {
      return false;
    }

    return true;
  } catch (error) {
    return false;
  }
};
